import styled from 'styled-components';

import { namedBreakpoints } from 'theme';

export const CmsTileModalLeftContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  flex-shrink: 0;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    width: 50%;
    height: 100%;
  }
`;

export const CmsTileModalLeftContentImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100% - 38px);
  overflow: hidden;
`;
